import endpoints from './endpoints';
import {fetch} from '../../lib/fetch';
import config from '../../configuration';

const functionHostKey = config.publicFunctionHostKey;

const service_request = {
  overview: async (id) => {
    const result = await fetch(`${endpoints.service_request}/overview/${id}`, {
      headers: {
        'x-functions-key': functionHostKey,
      },
    });

    const json = await result.json();
    return json;
  },
  details: async (id) => {
    const result = await fetch(`${endpoints.service_request}/details/${id}`, {
      headers: {
        'x-functions-key': functionHostKey,
      },
    });

    const json = await result.json();
    return json;
  },
  confirm: async (id, dealer_request_id, approved) => {
    const result = await fetch(`${endpoints.service_request}/confirm/${id}`, {
      method: 'POST',
      headers: {
        'x-functions-key': functionHostKey,
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({dealer_request_id, approved}),
    });

    const json = await result.json();
    return json;
  },
  reject: async (id, dealer_request_id) => {
    const result = await fetch(`${endpoints.service_request}/confirm/${id}`, {
      method: 'POST',
      headers: {
        'x-functions-key': functionHostKey,
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({dealer_request_id}),
    });

    const json = await result.json();
    return json;
  },
  new: async (dealer_id, payload) => {
    const result = await fetch(`${endpoints.service_request}/${dealer_id}`, {
      method: 'POST',
      headers: {
        'x-functions-key': functionHostKey,
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({...payload}),
    });

    const json = await result.json();
    return json;
  },
};

export default service_request;
